<script setup>
import {defineProps} from "vue"
defineProps({
  title: {type: String, default:"Meilleur rapport qualité/prix pour la famille"},
  color: {type: String, default:"color1"},
  bgIcon: {type: String, default:"icon: users; ratio: 8"},
  desc: {type: String, default:"En choisissant cité sainte augustine, vous économiser  de l'argent tout en bénéficiant de la qualité de nos services"},
})
</script>

<template>
  <li><!-- Reason Item #1 -->
    <div :class="'uk-card uk-card-default uk-card-body uk-box-shadow-medium '+ color+' impx-feature-item uk-position-relative'">
      <h6 class="uk-margin-remove-top uk-margin-bottom impx-text-white">{{title}}</h6>
      <p class="uk-margin-remove  impx-text-lighter">{{desc}}</p>
      <span data-uk-icon="{{bgIcon}}" class="feature-icon"></span>
    </div>
  </li><!-- Reason Item #1 End -->

</template>

<style scoped>

</style>